<script>
import axios from 'axios';

export default {
    data() {
        return {
            disabled: true,
            loading: false,
        }
    },

    methods: {
        async submit(e) {
            const formData = Object.fromEntries(new FormData(this.$refs.form));
            e.preventDefault();
            this.loading = true;
            this.$toast.clear();
            try {
                await axios.post('/api/brochure-form', formData);
                this.$toast.open(
                    this.$trans.get('courses-show.info-form.sent-ok')
                );
                this.disabled = true;
                this.$nextTick(this.reset);
            } catch (e) {
                this.$toast.error(
                    this.$trans.get('courses-show.info-form.sent-error')
                );
            }
            this.loading = false;
        },
        reset() {
            for (let el of [...this.$el.querySelectorAll('input')]) {
                if (el.type !== 'hidden') {
                    el.value = '';
                    el.checked = false;
                }
            }
        }
    },

    mounted () {
        for (let input of [...this.$el.querySelectorAll('input')]) {
            input.addEventListener('input', () => {
                this.disabled = ! this.$refs.form.checkValidity();
            });
        }
    },
}
</script>
